import * as angular from "angular";
import {IController} from "angular";
import * as _ from 'lodash'
import {PlanningRouteOverviewSettingsModel} from "../../models/planning-route-overview-settings.model";

export class PlanningRouteOverviewTableCtrl implements IController {
  activities: any;
  jobs: any;
  depots: any;
  selectedIds: string[];
  columns: PlanningRouteOverviewSettingsModel;
  onSelectChange: Function;

  public jobsMap: any;
  public depotsMap: any;
  public selectedKeys: any;
  private totalAccounts: any;
  public isScrollable: boolean = false;


  /* @ngInject */
  constructor() {
  }

  $onInit() {
    this.jobsMap = _.keyBy(this.jobs, (j) => {
      return j.id
    })
    this.depotsMap = _.keyBy(this.depots, function (d) {
      return d.id
    });
    this.totalAccounts = _.chain(this.activities)
      .filter(function (a) {
        return !!a.accountId
      })
      .map(function (filteredA) {
        return filteredA.accountId
      })
      .uniq()
      .value()
      .length;

    this._setScrollable(this.columns);
  }

  $onChanges(changes: angular.IOnChangesObject) {
    if (changes.activities && !changes.activities.isFirstChange()) {
      this.$onInit();
    }
    if (changes.jobs && !changes.jobs.isFirstChange()) {
      this.$onInit();
    }
    if (changes.depots && !changes.depots.isFirstChange()) {
      this.$onInit();
    }
    if (changes.columns && !changes.columns.isFirstChange()) {
      this._setScrollable(this.columns);
    }
    if (changes.selectedIds) {
      this.selectedKeys = {};
      _.forEach(this.selectedIds, (selectedId) => {
        this.selectedKeys[selectedId] = true;
      });
    }
  }

  toggleSelected(id) {
    this.selectedKeys[id] = !this.selectedKeys[id];
    const selectedIds = _.map(this.selectedKeys, (value, key) => {
      if (value) return key;
    });
    this.onSelectChange({selectedIds: _.compact(selectedIds)});
  }

  private _setScrollable(columns: PlanningRouteOverviewSettingsModel) {
    this.isScrollable = (Object.values(columns?.sections).filter(s => s).length > 3);
  }

}

angular
  .module('bringoz.admin.planning')
  .component('planningRouteOverviewTable', {
    bindings: {
      activities: '<',
      jobs: '<',
      depots: '<',
      selectedIds: '<',
      canSelect: '<?',
      columns: '<',
      onSelectChange: '&'
    },
    template: require('./planning-route-overview-table.html').default,
    controller: PlanningRouteOverviewTableCtrl
  });
